import { readAuthenticationCookie } from "./currentUser";
import { removeCookie } from "./cookies";
import { getStore } from "../store/createStore";
import { clearSemiAuthScope } from "../store/user/actions";

export const CustomerScope = "customer";
export const QuickManageScope = "quick_manage";

export function hasScope(scope) {
  const currentScope = readAuthenticationCookie().scope;
  return !!currentScope && currentScope.indexOf(scope) > -1;
}

export function isAuthenticated() {
  return readAuthenticationCookie().access_token !== undefined;
}

export function logout(removeGuestId = true) {
  if (isAuthenticated()) {
    removeCookie("ritual_auth-session", {
      path: "/",
      domain: process.env.GATSBY_COOKIE_DOMAIN,
    });

    if (removeGuestId) {
      removeCookie("guest_id", {
        path: "/",
        domain: process.env.GATSBY_COOKIE_DOMAIN,
      });
    }
  }

  getStore().dispatch(clearSemiAuthScope());
}
